import type { ValorModo } from '@/pages/assistente-evento/types';

export interface Ingresso {
  id: number | null;
  nome: string;
  valorModo: ValorModo;
  valorCentavos: number;
  temLimite: boolean;
  vagas: number | null;
  aVendaDeData: string;
  aVendaDeHora: string;
  aVendaAteData: string;
  aVendaAteHora: string;
  maxPorCompra: number;
  descricao: string;
}

export function nomeDeLote(numero: number): string {
  return `${numero}º lote`;
}

export function novoIngresso(): Ingresso {
  return {
    id: null,
    nome: '',
    valorModo: 'pago',
    valorCentavos: 0,
    temLimite: false,
    vagas: null,
    aVendaDeData: '',
    aVendaDeHora: '',
    aVendaAteData: '',
    aVendaAteHora: '',
    maxPorCompra: 10,
    descricao: '',
  };
}